var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAskByzIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ask",
    clipPath: "url(#clip0_395_8212)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.07688 13.8462C3.07688 14.2542 3.24797 14.6455 3.55251 14.934C3.85706 15.2225 4.27011 15.3846 4.70081 15.3846H14.4444L17.6923 18.4615V6.15385C17.6923 5.74582 17.5212 5.35451 17.2166 5.06599C16.9121 4.77747 16.499 4.61539 16.0683 4.61539H4.70081C4.27011 4.61539 3.85706 4.77747 3.55251 5.06599C3.24797 5.35451 3.07688 5.74582 3.07688 6.15385V13.8462Z",
    stroke: "#5E5E5E",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.6154 10.7692C14.6154 11.1772 14.4534 11.5686 14.1648 11.8571C13.8763 12.1456 13.485 12.3077 13.077 12.3077H3.84621L0.769287 15.3846V3.07691C0.769287 2.66889 0.931374 2.27757 1.21989 1.98906C1.50841 1.70054 1.89972 1.53845 2.30775 1.53845H13.077C13.485 1.53845 13.8763 1.70054 14.1648 1.98906C14.4534 2.27757 14.6154 2.66889 14.6154 3.07691V10.7692Z",
    fill: "white",
    stroke: "#5E5E5E",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_395_8212"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 18.4615,
    fill: "white",
    transform: "translate(0 0.769226)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAskByzIcon);
export default __webpack_public_path__ + "static/media/AskByzIcon.b262f3f6e0883572079b2baaf6324535.svg";
export { ForwardRef as ReactComponent };